import axios from 'axios';
import { toast } from 'react-toastify';

export function axios_interceptor () {
  axios.interceptors.request.use(request => {
    // add auth header with jwt if account is logged in and request is to the api url
    const token = localStorage.getItem("token");
    if (token) {
        request.headers.Authorization = `${token}`;
    }
    return request;
},
 error=> {
  alert(error)
    return Promise.reject(error);
  }
);


// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}, function (error) {
  if(error.response.status == 401 && error.response.data == "Unauthorized"){
    toast.error("Session Expired, Plesse login again"); 
      localStorage.clear();      
      sessionStorage.clear();  
      setTimeout(() => {
        window.location.href = "https://www.clinicaledify.com/"
      }, 5000);
     
      // window.location.reload();    
  }else{
      if(typeof error.response.data == "string"){
          // toast.error(error.response.data)
      }else if(typeof error.response.data == "object"){
        //  toast.error(error.response.data.errors.msg)
      }
  }
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  return Promise.reject(error);
});
}
